import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Legacy email-callback route (kept for old bookmark/email links).
 * Cloudflare-native auth uses /verify-email?token=… and /reset-password?token=….
 */
export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const verified = params.get("verified");
    if (verified === "1") {
      navigate("/login?verified=1", { replace: true });
      return;
    }
    navigate("/login", { replace: true });
  }, [navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}
